<template>
    <div>
        <v-card>
            <v-toolbar outlined flat>
                <v-subheader class="title">Reports</v-subheader>
                <v-spacer></v-spacer>
                <download-csv :data="records" name="report.csv"> <v-btn text color="accent"> CSV <v-icon>mdi-download</v-icon> </v-btn> </download-csv>
                <v-btn icon @click="edit = true"> <v-icon>mdi-cog</v-icon> </v-btn>
                <v-btn icon @click="close"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-toolbar>
            <v-data-table v-if="ready && pressed" :headers="headers" :items="records" :items-per-page="10" sort-by="date"></v-data-table>
        </v-card>
        <v-dialog v-model="edit" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Edit report</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="edit = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </v-toolbar>
                <v-card-text class="pt-6">
                    <v-card outlined>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto"> Report Type: </v-col>
                                <v-col cols="12" md="8">
                                    <v-select v-model="type" outlined dense hide-details flat :items="[{ text: '24 horas', value: 'hour' },{ text: 'Acumulado diario', value: 'day' }]"></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card outlined class="mt-3">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">From:</v-col>
                                <v-col cols="12" md="8">
                                    <v-menu ref="start" v-model="start.open" :close-on-content-click="false" :return-value.sync="start.date" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="start.date" dense solo flat outlined hide-details prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker locale="es-es" v-model="start.date" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="start.open = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.start.save(start.date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" offset-md="4" md="8">
                                    <v-text-field v-model="start.time" :disabled="type == 'day'" flat solo outlined dense type="time"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">To:</v-col>
                                <v-col cols="12" md="8">
                                    <v-menu ref="end" v-model="end.open" :disabled="type == 'hour'" :close-on-content-click="false" :return-value.sync="end.date" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="end.date" :disabled="type == 'hour'" dense solo flat outlined hide-details prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker :disabled="type == 'hour'" locale="es-es" v-model="end.date" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="end.open = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.end.save(end.date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-grey lighten-1" dark small @click="edit = false">Cancel</v-btn>
                    <v-btn color="accent" small @click="saveChanges">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Readings from '../../api/readings.api'

export default {
    name: 'tableReport',
    props: ['meter'],
    computed:{
        ...mapGetters({
            getDailyData: 'meters/getMeterData'
        })
    },
    data() {
        return {
            headers: [],
            records: [],
            ready: false,
            edit: false,
            type: 'hour',
            pressed: true,
            start:{
                open: false,
                date: null, 
                time: '12:30:00'
            },
            end:{
                open: false,
                date: null,
                time: '00:00:00'
            }
        }
    },
    methods: {
        ...mapActions({ 
            getHistoricData: 'meters/getHistoricData',
            getReadings: 'meters/queryReadings'
        }),
        async saveChanges(){
            try {
                if(!this.start.date) return
                
                // console.log(this.start);

                let start = this.formatDate(this.start.date, this.start.time)

                // console.log(start);

                if(this.type == 'hour'){
                    await this.formatDailyData({ 
                        start: start.getTime(),
                        end: start.getTime() + 1000 * 60 * 60 * 24
                    })
                    this.edit = false
                    return
                }

                if(!this.end.date) return

                let end = this.formatDate(this.end.date)

                await this.formatHistoric({ 
                    start: start.getTime(), 
                    end: end.getTime() 
                })
                this.edit = false
                return
            } catch (error) {
                console.log(error)
            }
        },
        formatDate(str_date, str_time){
            let [ year, month, day ] = str_date.split('-')
            let y = Number(year)
            let m = Number(month)
            let d = Number(day)
            let date = new Date(y, m-1, d)
            if(str_time) date.setHours(...str_time.split(':'))
            return date
        },
        async formatDailyData(query){
            try {
                this.ready = false
                this.records = []

                let data
                if(query) {
                    data = await this.getReadings({
                        meter: this.meter.name,
                        query
                    })
                } else {
                    data = await this.meter.data.reverse()
                }
                
                data.sort(( first, second ) => {
                    if(first._id.year < second._id.year) return -1;
                    if(first._id.year > second._id.year) return 1;
                    if(first._id.month < second._id.month) return -1;
                    if(first._id.month > second._id.month) return 1;
                    if(first._id.day < second._id.day) return -1;
                    if(first._id.day > second._id.day) return 1;
                
                    return 0;
                })

                this.headers = [
                    { text: 'Hour', value: 'date', sort: (one, two) => {
                        const date_one = new Date()
                        const date_two = new Date()
                        const one_split = one.split(' ').map((time, index) => time.split(index === 0 ? '/': ':') )
                        const two_split = two.split(' ').map((time, index) => time.split(index === 0 ? '/': ':') )

                        date_one.setFullYear(one_split[0][2], one_split[0][1], one_split[0][0])
                        date_two.setFullYear(two_split[0][2], two_split[0][1], two_split[0][0])
                        date_one.setHours(...one_split[1])
                        date_two.setHours(...two_split[1])
                        
                        return date_one.getTime() < date_two.getTime() ? -1 : 1;
                    } },
                    { text: 'Device', value: 'name' }
                ]

                for (let index = 0; index < this.meter.nlines; index++) {
                    this.headers.push({ text: `Amps ${index + 1}`, value: `amps${index + 1}` })
                    this.headers.push({ text: `Watts ${index + 1}`, value: `watts${index + 1}` })
                    this.headers.push({ text: `Volts ${index + 1}`, value: `volts${index + 1}` })
                }
                this.headers.push({ text: 'Kwh', value: 'kwh' })
                
                this.records = data.map( read => {
                    let record = {}
                    let month = new Date(read.timestamp).getMonth() + 1
                    let day = new Date(read.timestamp).getDate()
                    let year = new Date(read.timestamp).getFullYear()
                    let hour = moment(read.timestamp).format('LTS')
                    let hourConverted = moment(hour, "h:mm:ss A").format('HH:mm:ss')
                    let fullDate = String(month).concat('/', String(day), '/', String(year), ' ', hourConverted)
                    record.date = fullDate
                    record.name = this.meter.circuit

                    read.lines.forEach( l =>{
                        record[`amps${l.nline}`] = l.amps.toFixed(2)
                        record[`watts${l.nline}`] = l.watts.toFixed(2)
                        record[`volts${l.nline}`] = l.volts.toFixed(2)
                    })

                    record.kwh = read.lines[0].kwht.toFixed(2)
                    return record
                })

                this.ready = true

            } catch (error) {
                console.log(error)
            }
        },
        displayReports(){
            this.pressed = !this.pressed
        },
        async formatHistoric(dates){
            try {
                this.ready = false
                this.records = []
                this.headers = [
                    { text: 'Day', value: 'date', sort: (one, two) => {
                        const one_split = one.split('/')
                        const two_split = two.split('/')
                        const date_one = new Date()
                        const date_two = new Date()
                        date_one.setFullYear(one_split[2], one_split[1], one_split[0])
                        date_two.setFullYear(two_split[2], two_split[1], two_split[0])
                        
                        return date_one.getTime() < date_two.getTime() ? -1 : 1;
                    }},
                    { text: 'Device', value: 'name' }
                ]

                let { data } = await this.getHistoricData({
                    id_meter: this.meter.name,
                    ...dates
                    })
                
                for (let index = 0; index < this.meter.nlines; index++) {
                    this.headers.push({ text: `Amps ${index + 1} avg`, value: `amps${index + 1}` })
                    this.headers.push({ text: `Watts ${index + 1} avg`, value: `watts${index + 1}` })
                    this.headers.push({ text: `Volts ${index + 1} max`, value: `volts${index + 1}` })
                }
                this.headers.push({ text: 'Kwh', value: 'kwh' })

                data.sort(( first, second ) => {
                    if(first._id.year < second._id.year) return -1;
                    if(first._id.year > second._id.year) return 1;
                    if(first._id.month < second._id.month) return -1;
                    if(first._id.month > second._id.month) return 1;
                    if(first._id.day < second._id.day) return -1;
                    if(first._id.day > second._id.day) return 1;
                
                    return 0;
                })
                
                this.records = data.map( read => {
                    let record = {}
                    let day = new Date()
                    day.setUTCFullYear(read._id.year, read._id.month - 1, read._id.day)

                    record.date = day.toLocaleDateString()
                    record.name = this.meter.circuit   

                    read.lines.forEach( l =>{
                        record[`amps${l.nline}`] = l.amps.toFixed(2)
                        record[`watts${l.nline}`] = l.watts.toFixed(2)
                        record[`volts${l.nline}`] = l.volts.max.toFixed(2)
                    })

                    record.kwh = read.lines[0].kwht.toFixed(2)

                    this.ready = true
                    return record
                })
                
            } catch (error) {
                console.log(error)
            }
        },
        close(){
            this.$emit('close')
        }
    },
    mounted() {
        let date = new Date()
        date.setDate(date.getDate() - 1)
        this.start.time = `${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:00`
        this.start.date = `${date.getFullYear()}-${('0' + (date.getMonth()+1)).slice(-2)}-${('0' + (date.getDate())).slice(-2)}`
        this.formatDailyData()
    },
}
</script>

<style scoped>
    .title{
        text-transform: uppercase;
        padding: 0px;
        font-size: 0.9rem !important;
        font-weight: bold;
    }
</style>